import { useMatrix } from "~/context/MatrixContext";

export function SyncStatusBanner() {
  const { state } = useMatrix();
  if (state !== "syncing" && state !== "reconnecting") return null;
  const message =
    state === "syncing" ? "Updating…" : "Reconnecting… your messages will resume automatically.";
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "var(--chat-space-2)",
        height: "var(--chat-space-10)",
        padding: "0 var(--chat-space-4)",
        background: "var(--chat-surface-raised)",
        color: "var(--chat-fg-primary)",
        fontFamily: "var(--chat-font-sans)",
        fontSize: "var(--chat-type-body-sm-size)",
        lineHeight: "var(--chat-type-body-sm-line)",
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>{message}</span>
    </div>
  );
}
